import React, {useState} from 'react'
import QrCodeScanner from '../../../../components/QrCodeScanner/QrCodeScanner'

type Props = {
    onNext: (nalog: string) => void
}

const StepScanOrder: React.FC<Props> = ({onNext}) => {

    const [nalog, setNalog] = useState('')
    const [loading, setLoading] = useState(false)

    const onBtnClick = () => {
        if (!nalog) return

        setLoading(true)

        setTimeout(() => {
            onNext(nalog)
            setLoading(false)
        }, 300)
    }

    return (
        <div className='card border shadow-sm'>
            <div className='card-body p-3 p-md-5'>
                <div className='d-flex align-items-center gap-3 mb-4'>
                    <div
                        className='d-flex align-items-center justify-content-center rounded bg-light-primary'
                        style={{width: 40, height: 40, flex: '0 0 40px'}}
                    >
                        <i className='bi bi-upc-scan text-primary fs-3'/>
                    </div>
                    <div>
                        <h2 className='fw-bolder text-gray-900 mb-0' style={{fontSize: 18}}>
                            Identifikacija naloga
                        </h2>
                        <div className='text-muted fw-semibold fs-8'>
                            Skeniraj QR kod ili unesi broj naloga.
                        </div>
                    </div>
                </div>

                <div className='row g-3 align-items-end'>
                    <div className='col-auto'>
                        <label className='form-label text-muted fw-semibold fs-8 mb-1'>
                            QR
                        </label>

                        <div
                            className='d-flex align-items-center justify-content-center border rounded bg-light'
                            style={{width: 56, height: 52}}
                            title='Skeniraj QR'
                        >
                            <QrCodeScanner
                                onScan={(text) => {
                                    setNalog(text)

                                    // OPTIONAL AUTO NEXT AFTER SCAN
                                    // onNext(text)
                                }}
                            />
                        </div>
                    </div>

                    <div className='col'>
                        <label className='form-label text-muted fw-semibold fs-8 mb-1'>
                            Broj naloga
                        </label>

                        <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            value={nalog}
                            placeholder='Unesi broj naloga...'
                            onChange={(e) => setNalog(e.target.value)}
                            onKeyDown={(e) =>
                                e.key === 'Enter' && onBtnClick()
                            }
                            autoFocus
                        />
                    </div>

                    <div className='col-12 col-sm-auto'>
                        <button
                            className='btn btn-primary btn-lg px-5 w-100'
                            disabled={!nalog || loading}
                            onClick={onBtnClick}
                        >
                            {!loading ? (
                                <>
                                    Nastavi
                                    <i className='bi bi-arrow-right-circle ms-2'/>
                                </>
                            ) : (
                                <span className='d-inline-flex align-items-center gap-2'>
                                    Provjera...
                                    <span className='spinner-border spinner-border-sm'/>
                                </span>
                            )}
                        </button>
                    </div>
                </div>

                <div className='mt-3 px-3 py-2 rounded bg-light d-flex align-items-center justify-content-between gap-3'>
                    <span className='text-muted fw-semibold fs-8'>Trenutni nalog</span>
                    <span className='fw-bolder text-gray-900 text-break text-end'>{nalog || '-'}</span>
                </div>
            </div>
        </div>
    )
}

export default StepScanOrder
